import { useEffect, useState } from "react";
import { Trophy, Loader2 } from "lucide-react";
import { Reveal } from "./Reveal";
import api from "../lib/api";

const TournamentsSection = () => {
  const [tournaments, setTournaments] = useState(null);

  useEffect(() => {
    api.get("/tournaments").then((r) => setTournaments(r.data)).catch(() => setTournaments([]));
  }, []);

  return (
    <section id="tournaments" className="relative py-10 md:py-14">
      <Reveal>
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tighter flex items-center gap-3">
          <Trophy className="h-6 w-6 text-flame" /> Upcoming tournaments
        </h2>
        <p className="mt-2 text-muted-foreground">Cups and competitions coming up — get a team together.</p>
      </Reveal>

      {tournaments === null ? (
        <div className="mt-8 grid place-items-center py-12 text-muted-foreground" data-testid="tournaments-loading">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
      ) : tournaments.length === 0 ? (
        <div className="mt-8 rounded-3xl border-2 border-dashed border-foreground/15 p-10 text-center" data-testid="tournaments-empty">
          <Trophy className="h-8 w-8 mx-auto text-muted-foreground" />
          <p className="mt-3 font-display font-bold text-lg">No tournaments announced yet</p>
          <p className="text-sm text-muted-foreground mt-1">As soon as one is organised, it'll be here.</p>
        </div>
      ) : (
        <div className="mt-8 grid sm:grid-cols-2 gap-5">
          {tournaments.map((t, idx) => (
            <Reveal key={t.id} delay={0.04 * Math.min(idx, 4)}>
              <article data-testid="tournament-card" className="h-full rounded-3xl bg-card border border-foreground/10 p-6 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex flex-wrap items-center gap-2">
                  {t.date_label && (
                    <span className="rounded-full bg-pitch text-cream dark:bg-turf dark:text-background px-3 py-1 font-mono text-[10px] uppercase tracking-[0.18em] font-semibold">
                      {t.date_label}
                    </span>
                  )}
                  {t.entry_info && (
                    <span className="rounded-full bg-flame-soft dark:bg-flame/15 text-flame px-3 py-1 font-mono text-[10px] uppercase tracking-[0.14em] font-semibold">
                      {t.entry_info}
                    </span>
                  )}
                </div>
                <h3 className="mt-3 font-display text-xl font-bold tracking-tight leading-snug">{t.title}</h3>
                {t.venue && <p className="mt-1.5 text-sm text-muted-foreground">Where: {t.venue}</p>}
                {t.note && <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{t.note}</p>}
              </article>
            </Reveal>
          ))}
        </div>
      )}
    </section>
  );
};

export default TournamentsSection;
